import React, { Component } from "react";
import {
  Input,
  Button,
  Form,
  InputNumber,
  message,
  Radio,
  Select,
  Divider,
} from "antd";
import { Link, withRouter } from "react-router-dom";
import momenthijri from "moment-hijri";
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import DatePicker from "react-multi-date-picker";
// import arabic from "react-date-object/calendars/arabic";
// import arabic_ar from "react-date-object/locales/arabic_ar";
import "./Register.scss";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import cityscape from "../../assets/cityscape.png";
import localization from "../../Localization/Localization.json";
import { RegisterCustomer } from "../../network/auth.network";
import { connect } from "react-redux";
import { AddOrUpdateFinancingRequestForCustomer } from "../../network/request.network";

const { Option } = Select;

class Register extends Component {
  state = {
    btnLoading: false,
    setPassword: false,
    step: 1,
    numberVal: "",
    registerBody1: {},
    registerBody2: {},
    JobTitlesState: [],
    jobTitle: null,
    carBrand: null,
    checkJobTitle: false,
    IsSupport: 0,
    IdentityId: "",
  };

  handleEmployerChange = (value) => {
    const JobTitlesState = this.props?.JobTitles.filter(
      (title) => title.EmployerId === value
    );
    this.setState({ JobTitlesState, jobTitle: null, employerTitle: value });
    if (value === null) this.setState({ checkJobTitle: true });
    else this.setState({ checkJobTitle: false });
  };

  onTitleChange = (value) => {
    this.setState({ jobTitle: value });
  };

  onFinish = (values) => {
    if (!values.support) values.support = this.state.IsSupport;
    if (this.state.employerTitle === null)
      this.setState({ checkJobTitle: true });
    else this.setState({ checkJobTitle: false });
    this.setState({ btnSaveLoading: true });
    const phoneNumber = parsePhoneNumber(values.PhoneNumber || "");
    let body = {
      NationalIdentityNumber: values.NationalIdentityNumber,
      EmployerName: values.EmployerName,
      BirthDate: momenthijri(values.BirthDate?.toDate?.().toString()).format(
        "YYYY-MM-DD"
      ),
      //  "BirthDate": "2000-10-17T17:08:36.699Z",
      Salary: values?.customerSalary,
      IsSupported: values?.support ? true : false,
      IsSaudi: values?.IsSaudi ? true : true,
      SuportAmount: values?.SuportAmount,
      JobTitleId: this.state?.jobTitle,
      EmployerId: this.state?.employerTitle,
      GenderId: values?.customerGender,
      CityId: values?.CityId,
      WorkCityId: values?.WorkCityId,
      BankId: values?.BankId,
      PhoneNumber: phoneNumber?.nationalNumber,
      PhoneKey: "+" + phoneNumber?.countryCallingCode,
      Email: values?.Email,
      FullName: values?.FullName,
      Password: values?.Password,
      ConfirmPassword: values?.ConfirmPassword,
      ProfileImage: null,
      CarColorId: values?.CarColorId,
    };

    //console.log(body)

    RegisterCustomer(
      body,
      (res) => {
        let userBody = {
          Id: 0,
          CustomerId: res.data.model.Id,
          FinanceRequestSourceId: 2,
          CarFinancingRequest: {
            CarModelId: values?.CarModelId,
            CarColorId: values?.CarColorId,
          },
        };
        // AddOrUpdateFinancingRequestForCustomer(
        //   userBody,
        //   (res) => {
        //     message.success("تم التسجيل بنجاح");
        //     this.setState({ btnSaveLoading: false });
        //     setTimeout(() => {
        //       this.props.history.push("/signin");
        //     }, 500);
        //   },
        //   (err) => {
        //     //console.log(err)
        //     message.success("تم التسجيل بنجاح");
        //     this.props.history.push("/signin");
        //     this.setState({ btnSaveLoading: false });
        //   }
        //   );
        message.success("تم التسجيل بنجاح");
        // this.props.history.push("/signin");
        this.props.history.push({
          pathname: "/phone-verification",
          state: {
            PhoneKey:
              "+" + parsePhoneNumber(values?.PhoneNumber)?.countryCallingCode,
            PhoneNumber: parsePhoneNumber(values?.PhoneNumber)?.nationalNumber,
            email: body.Email,
            status: 1,
          },
        });
        this.setState({ btnSaveLoading: false });
      },
      (error) => {
        if (error.Code === 26) message.error("هذا العميل موجود بالفعل");
        else if (error.Code === 24)
          message.error("البريد الإلكترونى موجود لدى عميل آخر");
        else if (error.Code === 4 || error.Code === 22)
          message.error("رقم الهاتف موجود بالفعل لعميل آخر");
        this.setState({ btnSaveLoading: false });
      }
    );
  };

  render() {
    const {
      btnLoading,
      carBrand,
      employerTitle,
      jobTitle,
      JobTitlesState,
      btnSaveLoading,
    } = this.state;
    console.log(carBrand, "carBrand");
    return (
      <div className="new-order-wrapper register-form-wrapper page-wrapper-no-header">
        <div className="container">
          <div className="order-header">
            <div className="order-header-info">
              <h1>حساب جديد</h1>
              <p>أنت علي بعد خطوات قليله لإنشاء حساب جديد خاص بك</p>
            </div>
            <img src={cityscape} alt="" />
          </div>

          <div className="new-order-form">
            <Form
              id="register-form"
              className="add__record--form "
              layout="vertical"
              name="nest-messages"
              onFinish={this.onFinish}
              initialValues={{
                customerGender: 1,
              }}
            >
              <div className="form-content">
                {/* <Form.Item
                  label="البنك المفضل"
                  name="BankId"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك حدد البنك",
                    },
                  ]}
                >
                  <Select>
                    {this.props.Banks?.map((bank) => {
                      return (
                        <Select.Option key={bank.Id} value={bank.Id}>
                          {bank.NameLT}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="اللون المفضل"
                  name="CarColorId"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك حدد اللون",
                    },
                  ]}
                >
                  <Select>
                    {this.props.CarColors?.map((color) => {
                      return (
                        <Select.Option key={color.Id} value={color.Id}>
                          {color.NameLT}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="براند السياره"
                  name="CarModelId"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك حدد براند السياره",
                    },
                  ]}
                >
                  <Select
                    onChange={(data) => this.setState({ carBrand: data })}
                  >
                    {this.props.CarBrands?.map((color) => {
                      return (
                        <Select.Option key={color?.Id} value={color?.Id}>
                          {color?.NameLT}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="ماركه السياره"
                  name="CarModelId"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك حدد ماركه السياره",
                    },
                  ]}
                >
                  <Select>
                    {this.props.CarModels?.filter(
                      (model) => +model?.Id === +carBrand
                    )?.map((model) => {
                      return (
                        <Select.Option key={model?.Id} value={model?.Id}>
                          {model?.NameLT}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item> */}

                {/* <Divider className="divider-style" orientation="right">
                  بيانات شخصيه
                </Divider> */}
                <Form.Item
                  label="رقم هوية العميل"
                  name="NationalIdentityNumber"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل رقم هوية العميل",
                    },
                    {
                      len: 10,
                      message: "رقم الهوية يتكون من 10 أرقام",
                    },
                  ]}
                >
                  <Input placeholder="" />
                </Form.Item>

                <Form.Item
                  label="اسم العميل"
                  name="FullName"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل اسم العميل",
                    },
                  ]}
                >
                  <Input placeholder="" />
                </Form.Item>
                <Form.Item
                  label="البريد الالكتروني"
                  name="Email"
                  className="input-holder"
                  rules={[
                    {
                      type: "email",
                      message: "من فضلك ادخل بريد إلكتروني صحيح",
                    },
                    {
                      required: true,
                      message: "من فضلك ادخل البريد الإلكتروني",
                    },
                    // {
                    //   pattern: new RegExp('[a-zA-Z0-9]{0,}([.]?[a-zA-Z0-9]{1,})[@](gmail|hotmail|outlook)'),
                    //   message: 'من فضلك ادخل بريد إلكتروني منتهياً ب gmail - outlook - hotmail',
                    // }
                  ]}
                >
                  <Input placeholder="" />
                </Form.Item>

                <Form.Item
                  label="رقم الجوال"
                  name="PhoneNumber"
                  className="input-holder"
                  rules={[
                    {
                      validator(_, value) {
                        let phoneValid = isValidPhoneNumber(value || "");
                        if (!value)
                          return Promise.reject("من فضلك ادخل رقم الجوال");
                        else if (!phoneValid)
                          return Promise.reject("رقم الجوال غير صحيح");
                        else return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <PhoneInput
                    international
                    countryCallingCodeEditable={false}
                    defaultCountry="SA"
                    value={this.state.numberVal}
                    onChange={(val) => this.setState({ numberVal: val })}
                  />
                </Form.Item>

                {/* <Form.Item
                  label="تاريخ الميلاد"
                  name="BirthDate"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل تاريخ الميلاد",
                    },
                  ]}
                >
                  <DatePicker
                    maxDate={new Date().setFullYear(
                      new Date().getFullYear() - 1,
                      0,
                      1
                    )}
                    // calendar={arabic}
                    // locale={arabic_ar}
                  />
                </Form.Item>
                <Form.Item
                  label="الجنسيه"
                  name="IsSaudi"
                  className="input-holder"
                >
                  <Radio.Group name="radiogroup" defaultValue={true}>
                    <Radio value={true}>سعودي</Radio>
                    <Radio value={false}>غير سعودي</Radio>
                  </Radio.Group>
                </Form.Item> */}

                <Form.Item
                  label="كلمة المرور "
                  name="Password"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل كلمة المرور الجديد",
                    },
                    {
                      min: 8,
                      message: "يجب ان تكون كلمة المرور أكبر من 8 أحرف",
                    },
                    {
                      max: 20,
                      message: "يجب ان تكون كلمة المرور اقل من 20 حرف",
                    },
                    // {
                    //     //Password expresion that requires one lower case letter, one upper case letter, one digit, 6-13 length, and no spaces.This is merely an extension of a previously posted expression by Steven Smith(ssmith@aspalliance.com) . The no spaces is new.
                    //     pattern: new RegExp(
                    //         "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,20})"
                    //     ),
                    //     message: "يجب أن تحتوي كلمة المرور على حروف كبيرة وأرقام ورموز",

                    // },
                  ]}
                >
                  <Input.Password
                    className="input-control"
                    placeholder="كلمة المرور"
                  />
                </Form.Item>

                <Form.Item
                  label="تاكيد كلمه المرور"
                  name="ConfirmPassword"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: `${localization.pleaseInput["ar"]} ${localization.confirmpassword["ar"]}`,
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("Password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(`${localization.Thetwopasswords["ar"]}`)
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    className="input-control"
                    placeholder="تاكيد كلمه المرور"
                  />
                </Form.Item>
                {/* <Divider className="divider-style" orientation="right">
                  بيانات الوظيفه
                </Divider>
                <div>
                  <Form.Item
                    label=" جهة العمل"
                    name="customerWork"
                    className="input-holder select-group-holder"
                    style={{ marginBottom: "0px" }}
                  >
                    <Select
                      value={employerTitle}
                      onChange={this.handleEmployerChange}
                    >
                      {this.props?.Employers?.map((emp) => {
                        return (
                          <Select.Option key={emp.Id} value={emp.Id}>
                            {emp.NameLT}
                          </Select.Option>
                        );
                      })}
                    </Select>
                    <Divider style={{ height: 30 }} type="vertical" />
                    <Select
                      value={jobTitle}
                      onChange={this.onTitleChange}
                      disabled={employerTitle == 2}
                      placeholder="الرتبه"
                    >
                      {JobTitlesState?.map((title) => {
                        return (
                          <Select.Option key={title.Id} value={title.Id}>
                            {title.NameLT}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                  {this.state?.checkJobTitle && (
                    <span
                      style={{
                        color: "#fe5252",
                        textAlign: "right",
                        marginTop: "-10px",
                      }}
                    >
                      من فضلك حدد جهة العمل
                    </span>
                  )}
                </div>
                <Form.Item
                  label=" اسم جهة العمل"
                  name="EmployerName"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل اسم جهة العمل",
                    },
                  ]}
                >
                  <Input placeholder="" />
                </Form.Item>
                <Form.Item
                  label="نوع العميل"
                  name="customerGender"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك حدد الجنس",
                    },
                  ]}
                >
                  <Select>
                    {this.props.Genders?.map((gender) => {
                      return (
                        <Select.Option key={gender.Id} value={gender.Id}>
                          {gender.NameLT}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="الراتب الاساسي"
                  name="customerSalary"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك ادخل راتب العميل",
                    },
                  ]}
                >
                  <InputNumber min={0} />
                </Form.Item>
                <Form.Item
                  label="عنوان العمل"
                  name="WorkCityId"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك حدد عنوان العمل",
                    },
                  ]}
                >
                  <Select>
                    {this.props.Cities?.map((city) => {
                      return (
                        <Select.Option key={city.Id} value={city.Id}>
                          {city.NameLT}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="عنوان السكن"
                  name="CityId"
                  className="input-holder"
                  rules={[
                    {
                      required: true,
                      message: "من فضلك حدد عنوان السكن",
                    },
                  ]}
                >
                  <Select>
                    {this.props.Cities?.map((city) => {
                      return (
                        <Select.Option key={city.Id} value={city.Id}>
                          {city.NameLT}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="مدعوم"
                  name="support"
                  className="input-holder"
                >
                  <Radio.Group
                    name="radiogroup"
                    onChange={(e) =>
                      this.setState({ IsSupport: e.target.value })
                    }
                    defaultValue={0}
                  >
                    <Radio value={1}>نعم</Radio>
                    <Radio value={0}>لا</Radio>
                  </Radio.Group>
                </Form.Item>
                {this.state.IsSupport ? (
                  <Form.Item
                    label="قيمه الدعم"
                    name="SuportAmount"
                    className="input-holder"
                    rules={[
                      {
                        required: true,
                        message: "من فضلك ادخل قيمه الدعم",
                      },
                    ]}
                  >
                    <Input type="number" placeholder="" />
                  </Form.Item>
                ) : null}
               */}
              </div>
            </Form>
          </div>

          <div className="add__form--footer">
            <Button danger size="large" key="2" className="secondary_fill">
              <Link to="/signin">
                <FaAngleRight />
                الغاء
              </Link>
            </Button>
            <Button
              form="register-form"
              type="primary"
              size="large"
              htmlType="submit"
              loading={btnSaveLoading}
            >
              تسجيل
              <FaAngleLeft />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLang: state.user.currentLang,
  Cities: state.user.metaData?.Cities || [],
  Banks: state.user.metaData?.Banks || [],
  CarColors: state.user.metaData?.CarColors || [],
  CarModels: state.user.metaData?.CarModels || [],
  CarBrands: state.user.metaData?.CarBrands || [],
  Genders: state.user.metaData?.Genders || [],
  Employers: state.user.metaData?.Employers || [],
  JobTitles: state.user.metaData?.JobTitles || [],
});

const RegisterWithRouter = withRouter(Register);
export default connect(mapStateToProps)(RegisterWithRouter);
